/* Opal Cosmetics - free shipping progress bar (cart drawer + cart page) */
(function () {
  if (window.__opalFreeShipping) return;
  window.__opalFreeShipping = true;

  var THRESHOLD = 801 * 100; /* EGP in subunits */
  var AR = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var total = null;

  function egp(cents) {
    return Math.ceil(cents / 100).toLocaleString('en-US');
  }

  function message(remaining) {
    if (remaining <= 0) {
      return AR ? '🎉 مبروك! طلبك عليه شحن مجاني' : '🎉 Your order ships free!';
    }
    return AR
      ? 'باقيلك ' + egp(remaining) + ' جنيه وتاخد شحن مجاني 🚚'
      : 'Add EGP ' + egp(remaining) + ' more for free shipping 🚚';
  }

  function render() {
    if (total === null) return;
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      if (!ctas.querySelector('button[name="checkout"]')) return;
      var bar = ctas.previousElementSibling;
      if (!bar || !bar.classList.contains('opal-fsb')) {
        bar = document.createElement('div');
        bar.className = 'opal-fsb';
        bar.setAttribute('dir', AR ? 'rtl' : 'ltr');
        bar.style.cssText = 'margin:0 0 14px';
        bar.innerHTML =
          '<p class="opal-fsb__text" style="margin:0 0 6px;font-size:1.4rem;text-align:center;line-height:1.4"></p>' +
          '<div style="height:8px;border-radius:4px;overflow:hidden;background:rgba(var(--color-foreground),.12)">' +
            '<div class="opal-fsb__fill" style="height:100%;width:0;border-radius:4px;transition:width .4s ease"></div>' +
          '</div>';
        ctas.parentNode.insertBefore(bar, ctas);
      }
      var hidden = total <= 0;
      if (bar.hidden !== hidden) bar.hidden = hidden;
      var remaining = THRESHOLD - total;
      var text = message(remaining);
      var textEl = bar.querySelector('.opal-fsb__text');
      if (textEl.textContent !== text) textEl.textContent = text;
      var fill = bar.querySelector('.opal-fsb__fill');
      var width = Math.min(100, Math.max(0, (total / THRESHOLD) * 100)).toFixed(1) + '%';
      var color = remaining <= 0 ? '#1f9d55' : '#257FCD';
      if (fill.style.width !== width) fill.style.width = width;
      if (fill.dataset.color !== color) { fill.dataset.color = color; fill.style.background = color; }
    });
  }

  var fetching = null;
  function refresh() {
    if (fetching) return fetching;
    fetching = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { total = cart.total_price || 0; render(); })
      .catch(function () {})
      .then(function () { fetching = null; });
    return fetching;
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; render(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 150); });
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.quantity__button, cart-remove-button button');
    if (t) setTimeout(refresh, 900);
  });

  refresh();
})();
